
















































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Sync} from 'vuex-pathify';
import VendorDialog from '@/components/Views/Vendor/VendorDialog.vue';
import {Mixins} from 'vue-property-decorator';
import VendorMixin from '@/mixins/VendorMixin.vue';
import ImportDialog from '@/components/Views/Dashboard/Import & Export/ImportDialog.vue';
import {debounce, pickBy} from 'lodash';
import ImageGrid from '@/components/Views/UI/ImageGrid.vue';
import ImageGrid2 from '@/components/Views/UI/ImageGrid2.vue';
import SelectImportedFilesDialog from '@/components/Views/Dashboard/Import & Export/SelectImportedFilesDialog.vue';
import {nil} from '@/common';

@Component({
    components: {
        SelectImportedFilesDialog,
        ImageGrid2,
        ImageGrid,
        ImportDialog,
        VendorDialog,
    },
})
export default class DashboardVendorProfile extends Mixins(VendorMixin) {
    @Sync('auth/user') private user!: any;
    private loading = true;
    private vendor: any | null = null;
    private savedMessage = false;
    public imageLimit = 25;
    private images = [];
    public mounted() {
        this.initialize();
    }
    @Watch('vendor')
    public onVendorChanged(value: any, oldValue: any) {
    }
    private async initialize() {
        this.loading = true;
        const {Vendor} = this.$FeathersVuex;
        this.vendor = this.user.vendorModel;
        this.vendor = await Vendor.get(this.vendor._id);
        this.loading = false;
        // this.vendor = response.data[0] || null;
        // this.images = await this.vendorWorkImages(this.vendor);
    }
    private aboutMeChanged = debounce(() => {
        this.saveAboutMe();
    }, 850);

    private saveAboutMe() {
        this.savedMessage = true;
        this.vendor.save();
    }
    public get asSelectionMap() {
        const obj = {};
        if (nil(this.vendor) || nil(this.vendor.workImages, true)) { return obj; }
        for (const image of this.vendor.workImages) {
            obj[image] = true;
        }
        return obj;
    }
    public set asSelectionMap(value) {
        this.vendor.workImages = Object.keys(pickBy(value, (x) => x));
        this.vendor.save();
    }
    public imagesAdded(data) {
        // this.refreshService();
        this.vendor.workImageModels.push(data);
        this.vendor.workImages.push(data._id);
    }
    public get selectedProfileImage() {
        const obj = {};
        if (nil(this.vendor) || nil(this.vendor.profileImage)) { return obj; }
        obj[this.vendor.profileImage] = true;
        return obj;
    }
    public set selectedProfileImage(value) {
        this.vendor.profileImage = Object.keys(pickBy(value, (x) => x))[0];
        this.vendor.save();
    }


}
